export default function About({ showNavLinks }) {
  return (
    <>
      <h1>About Hubert's HUB</h1>
      <p>Hubert's HUB is a wiki for work, projects, or random ideas.</p>
      <p>
        HUB is created with mobile note-jotting in mind, so you can quickly
        update, look up, or add information on the go.
      </p>

      {showNavLinks ? (
        <p>
          Retrieve the SMS phone at{" "}
          <a href="/phone" target="_blank">
            /phone
          </a>
          .
        </p>
      ) : (
        <p>
          Sign up at{" "}
          <a href="https://hubert.wiki" target="_self">
            hubert.wiki
          </a>
          .
        </p>
      )}
      <p>
        <strong>
          HUB is created by{" "}
          <a href="https://smessina.com" rel="noreferrer" target="_blank">
            Sam Messina
          </a>
          .
        </strong>
      </p>
    </>
  );
}
